
__webpack_require__.initializeExposesData = {
  moduleMap: {
  "./App": () => {
return Promise.all([__webpack_require__.e("529"), __webpack_require__.e("561"), __webpack_require__.e("143"), __webpack_require__.e("923")]).then(() => (() => (__webpack_require__(2840))));
},
},
  shareScope: "default",
};
__webpack_require__.getContainer = __webpack_require__.getContainer || function() { throw new Error("should have __webpack_require__.getContainer") };__webpack_require__.initContainer = __webpack_require__.initContainer || function() { throw new Error("should have __webpack_require__.initContainer") };